import { calendar_day } from "./Calendar_Day";

export class calendar_week {
  public days: calendar_day[];
}
